import moment from 'moment'

/**
 * Groups expenses into calendar weeks (local start-of-week) for week tabs.
 */
export const getExpensesAvailableWeeks = expenses => {
  const weeks = {}

  expenses.forEach(expense => {
    const date = moment(expense.incurredDate)
    const week = date.clone().startOf('week')
    const formattedWeek = week.clone().format('MM/DD/YYYY')

    weeks[formattedWeek] = {
      start: week,
      end: date.clone().endOf('week'),
      stringWeek: `Week of ${formattedWeek}`,
    }
  })

  return Object.entries(weeks).map(([_, week]) => week)
}
